import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { NotificationService } from '../notification.service';
import { ToastMessage, ToastVariant } from '../notification.models';

interface ToastVisual {
  icon: string;
  containerClass: string;
  iconClass: string;
  titleClass: string;
}

@Component({
  selector: 'app-toast-host',
  standalone: true,
  imports: [IonIcon],
  templateUrl: './toast-host.component.html',
  styleUrl: './toast-host.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastHostComponent {
  private readonly notification = inject(NotificationService);

  readonly toasts = this.notification.toasts;

  dismiss(id: string): void {
    this.notification.dismiss(id);
  }

  visual(toast: ToastMessage): ToastVisual {
    return TOAST_VISUALS[toast.variant];
  }

  trackById(_index: number, toast: ToastMessage): string {
    return toast.id;
  }
}

const TOAST_VISUALS: Record<ToastVariant, ToastVisual> = {
  success: {
    icon: 'checkmark-circle',
    containerClass: 'border-emerald-200/80 bg-emerald-50/95',
    iconClass: 'text-emerald-600',
    titleClass: 'text-emerald-950',
  },
  error: {
    icon: 'close-circle-outline',
    containerClass: 'border-red-200/80 bg-red-50/95',
    iconClass: 'text-red-600',
    titleClass: 'text-red-950',
  },
  warning: {
    icon: 'warning-outline',
    containerClass: 'border-amber-200/80 bg-amber-50/95',
    iconClass: 'text-amber-600',
    titleClass: 'text-amber-950',
  },
  info: {
    icon: 'information-circle-outline',
    containerClass: 'border-[#0d6e7a]/20 bg-[#f0f9fa]/95',
    iconClass: 'text-[#0d6e7a]',
    titleClass: 'text-[#0a4f58]',
  },
};
